<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div v-if="availableTPs.length>0">
              <div class="row mb-1">
                <div class="col-6">
                  <select v-model="selectedtrainingplan" @change="getDash(null)">
                    <option v-for="tp in availableTPs" :value="tp.CurriculumID">{{tp.CurriculumName}}</option>
                  </select>
                </div>
                <div class="col-6">
                  <div style="float:right;padding-right:25px;"><button class="btn-transparent" @click="doTest" onclick="wind=window.open();"><font-awesome-icon icon="cog"></font-awesome-icon> Test</button><br /><button class="btn-transparent" @click="doSurveys" ><font-awesome-icon icon="file-alt"></font-awesome-icon> Reports</button></div>
                  <div style="clear:both;"></div>
                </div>
              </div>
              <hr />

              <div v-show="dashnodata===false">
                <trainingplandash ref="tpDash"></trainingplandash>
                <hr />
                <wondertable v-if="wtdata!==null" :wtID="'trainingPlanSummary'" :tcapiData="wtdata" :methods="wtmethods" :noRecords="''" :defaultDirection="0"
                             :ids="wids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="'Training Plan Users'" ref="wtRef"></wondertable>
              </div>
              <div v-show="dashnodata===true">
                There are no member data for this training plan
              </div>

            </div>
            <div v-if="availableTPs.length===0">
              There are no Training Plans assigned to this license pool
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <acfooter></acfooter>
    <b-modal title="Associated Members" ref="rPopList" scrollable ok-only size="xl">
      <div v-if="poplist!==null">
  
        <div v-show="poplist.length>0">
          <div class="row">
            <div class="col-6">
              <b>User</b>
            </div>
            <div class="col-4">
              <b>Last Lesson Accessed</b>
            </div>
            <div class="col-2">
              &nbsp;
            </div>
          </div>
          <div v-for="item in poplist" class="row">
            <div class="col-6 text-left" v-html="item.Name"> </div>
            <div class="col-4" v-html="item.LastCourse">
            </div>
            <div class="col-2">
              <button class="btn-transparent" @click="deleteMemberFromCurricula(item.ClientID)"><font-awesome-icon icon="times" aria-label="Remove"></font-awesome-icon></button>
            </div>
          </div>
        </div>
      
        <div v-show="poplist.length===0">
          There are no members associated with this training plan
        </div>
      </div>
    </b-modal>
    <b-modal title="Reports" ref="rSurveyList" scrollable ok-only>
      <div v-if="surveylist!==null">
        <p><b>Transcript Reports</b></p>
        <p><a href="javascript:void(0)" @click="goTranscriptReport()">Go to Transcript Reports</a></p>
        <hr />
        <p><b>Questionnaire Reports</b></p>
        <div v-show="surveylist.length>0">
           <div class="row" v-for="survey in surveylist">
               <div class="col-9">
                   {{survey.Key}}
               </div>
               <div class="col-3">
                   <a href="javascript:void(0)" @click="getSurveyData(survey.Key,survey.Value)">Get Data</a>
               </div>
           </div>
        </div>

        <div v-show="surveylist.length===0">
          There are no questionnaires associated with this training plan
        </div>
      </div>

    </b-modal>
    <b-modal title="Training Plan History" ref="rTPHistory" scrollable ok-only size="lg">
       
       <div v-if="trainingPlanHistory!==null&&trainingPlanHistory.length>0" v-for="i in trainingPlanHistory" v-html="i"></div>
       <div v-if="trainingPlanHistory!==null&&trainingPlanHistory.length===0">There are no history data for this training plan for this member</div>
    </b-modal>
  </div>
</template>

<style scoped>
  .card-title {
     height:75px;
  }
  .curriculum-card-links {
    margin-top: 50px;
  }
</style>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"
  import trainingplandash from "../../components/TrainingPlanDash.vue"
  import wondertable from "../../components/WonderTable.vue"

  export default {
    name: 'PoolCurricula',
    components: {acheader,acfooter,poolsidebar,trainingplandash,wondertable},
    data() {
      return {
        availableTPs: [],
        dashnodata:null,
        poplist:[],
        selectedtrainingplan:null,
        surveylist:null,
        trainingPlanHistory:null,
        wids: ["ClientID"],
        wtdata: null,
        wtmethods: {
          doHistory: {
            method: function(param, ref) {
              ref.doHistory(param.ClientID);
            },
            ref: this
          },
          doRemove: {
            method: function(param, ref) {
              ref.deleteMemberFromCurricula(param.ClientID);
            },
            ref: this
          },
          doReset: {
            method: function(param, ref) {
              ref.doReset(param.ClientID);
            },
            ref: this
          }
        }
      }
    },
    methods: {
      deleteMemberFromCurricula(ClientID) {
        if (this.sdata.activepool.IsAdmin) {
          this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this member from the training plan? This action cannot be undone!', {
            title: 'Confirm Removal',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }).then(value => {
            if (value) {
              this.apiCommand([
                {
                  Operation: "LicensePool",
                  Function: "DeleteMemberCurriculum",
                  Fields: {
                    LicensePoolID: this.$route.params.id,
                    CurriculumID: this.selectedtrainingplan,
                    ClientID: ClientID
                  }
                }
              ]).then(r=> {
                this.popDialog(0, "Member successfully removed from the training plan");
                this.getDash(this.selectedtrainingplan);
              });
            }
          });
        }
        else {
          this.popDialog(1, "This operation is not available to data-viewers");
        }
      },
      doCertButton(tp,cl) {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetTPCertificateForUser",
            Fields: {
              TrainingPlanID: tp,
              ClientID: cl
            }
          }
        ]).then(r=>{
          this.popDialog(0, "Certificate has been sent to your email");
        });
      },
      doHistory(ClientID) {
        this.apiCommand([
         {
           Operation: "Client",
           Function: "GetTrainingPlanHistory",
           Fields: {
             TrainingPlanID: this.selectedtrainingplan,
             ClientID: ClientID,
             RemoveCompletionText: "true",
             LicensePoolID: this.$route.params.id
           }
         }
        ]).then(r=>{
          var cr = JSON.parse(r.CommandResult);
          var tph =JSON.parse(cr.returnObjects[0].returnObject);
          if (tph.length>0 && tph[0].indexOf("CERTACCESS")>-1) {
            tph[0]=tph[0].replace("[CERTACCESS]","<button class='btn btn-secondary btn-short' style='display:inline;' onclick='Ext.Vue.$bus.$emit(\"TPCertEvent\", \""+this.selectedtrainingplan+"\", \""+ClientID+"\")'>Get Certificate</button>")
          }
          this.trainingPlanHistory=tph;
          this.$refs.rTPHistory.show();
        });
      },
      doReset(ClientID) {
        if (this.sdata.activepool.IsAdmin) {
            this.$bvModal.msgBoxConfirm('Are you sure you wish to reset this training plan for this student? This is a FULL reset and ALL DATA will be lost! This action cannot be undone!', {
              title: 'Confirm Reset',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              okTitle: 'Yes',
              cancelTitle: 'No',
              footerClass: 'p-2',
              hideHeaderClose: false,
              centered: true
            }).then(value=>{
              if (value) {
                this.apiCommand([
                 {
                   Operation: "LicensePool",
                   Function: "ResetCurriculum",
                   Fields: {
                     CurriculumID: this.selectedtrainingplan,
                     ClientID: ClientID,
                     IsStarted: "false"
                   }
                 }
                ]).then(r=> {
                  this.popDialog(0, "Member training plan successfully reset");
                  this.getDash(this.selectedtrainingplan);
                });
              }
            });
        }
        else {
          this.popDialog(1, "This operation is not available to data-viewers");
        }
        
      },
      doSurveys() {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetQuestionnairesForTrainingPlan",
            Fields: {
              TrainingPlanID: this.selectedtrainingplan,
              LicensePoolID: this.$route.params.id
            }
          }
        ]).then(r=>{
          var cr = JSON.parse(r.CommandResult);
          this.surveylist=JSON.parse(cr.returnObjects[0].returnObject);
          this.$refs.rSurveyList.show();
        });
      },
   
      doGenericAvatar(item) {
        item.FullImage="/curriculum.svg";
        this.$forceUpdate();
      },
      doTest() {
        this.apiCommand([
           {
             Operation: "Client",
             Function: "SimCurriculaLogin",
             Fields: {
               CurriculumID: this.selectedtrainingplan,
               IsTestMode: "true"
             }
           }
        ]).then(response=> {

          var cr = JSON.parse(response.CommandResult);
          var url = cr.returnObjects[0].returnObject;

          if (url.indexOf("http")>=0)
          {
            wind.location.href = url;
          }
          else {
            wind.close();
            this.popDialog(1, url);
          }

        });
      },
    
      getSurveyData(qName,qID) {

        var ud =JSON.parse(localStorage.getItem("udata"));
        var d = new Date();
        d.setDate(d.getDate() + 1);
        var eddate = d.getMonth()+"/"+d.getDate()+"/"+d.getFullYear();

        this.apiCommand([
         {
           Operation: "Question",
           Function: "GetReport",
           Fields: {
             QuestionnaireID: qID,
             StartDate:"1/1/2000",
             EndDate:eddate,
             FOA:"false"
           }
         }
        ]).then(r=> {
          this.popDialog(0, "Report request sent. You should receive the report in your email shortly");
        });


      },
      getDash(CurriculumID) {

        if (CurriculumID===null) {
          CurriculumID=this.selectedtrainingplan;
        }

        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetCurriculaDashboard",
            Fields: {
              LicensePoolID: this.$route.params.id,
              CurriculumID: CurriculumID
            }
          }
        ]).then(r=> {
          var cr = JSON.parse(r.CommandResult);
          var cd = JSON.parse(cr.returnObjects[0].returnObject);

          if (cd.TrainingPlanUsers.length>0) {
            this.dashnodata=false;
            this.$refs["tpDash"].setData(cd);
            if (this.wtdata==null) {
              this.wtdata=cd.TrainingPlanUsers;
            }
            else {
              this.wtdata=cd.TrainingPlanUsers;
              this.$refs["wtRef"].renderTable(cd.TrainingPlanUsers);
            }
          }
          else {
            this.dashnodata=true;
          }
        });
      
      },
      goTranscriptReport() {
        localStorage.setItem("tpBypass","true");
        this.$router.push({ name: 'poolreporting', params: { id: this.$route.params.id } });
      }
    },
    mounted() {

      Ext.Vue=this;

      this.$bus.$on("TPCertEvent", (param1,param2)=>{
        this.doCertButton(param1,param2);
      });

      this.doPage().then(r=>{
        this.bootstrapPool(this.$route.params.id);

        this.apiCommand([
            {
              Operation: "LicensePool",
              Function: "GetCurricula",
              Fields: {
                LicensePoolID: this.$route.params.id
              }
            }
        ]).then(r=> {

          var cr = JSON.parse(r.CommandResult);
          var curricula = JSON.parse(cr.returnObjects[0].returnObject);
          for(var curriculum of curricula) {
            curriculum.FullImage=this.$hostname+"/Streamable.svc/GetImage?type=curriculum&ID="+curriculum.CurriculumID
          }

          if (curricula.length>0) {
            this.availableTPs=curricula;
            this.selectedtrainingplan=curricula[0].CurriculumID;
            this.getDash(curricula[0].CurriculumID);
          }

        });
      });
    }
  }
</script>
